var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{ref:"datePicker",attrs:{"small":true,"inputStyle":'width: 140px;'},on:{"onChange":_vm.onChangeDate}})}
var staticRenderFns = []

export { render, staticRenderFns }